import React, { useCallback, useEffect } from "react";
import Socket from "socket";
import _ from "lodash";
import ActivePlayerPlaying from "../components/ActivePlayerPlaying";
import PlayingWaitingScreen from "../components/PlayingWaitingScreen";
import useSound from "use-sound";
import { motion } from "framer-motion/dist/framer-motion";
import {
  
  divVariants
} from "shared/components/animations";
const OCHPlaying = ({
  isActivePlayer,
  ActiveCard,
  ActivePlayerInfo,
  roomId,
  currentPlayerCard,users,currentPlayer,crazySuit,sounds,DrawDeck,joke
}) => {
  const [draw_sound] = useSound(sounds?.draw_card); 
  const [play_card] = useSound(sounds?.play_card);
  const [play_passing] = useSound(sounds?.passing);

  const [play_eight] = useSound(sounds?.play_eight);
  const [your_turn] = useSound(sounds?.your_turn);
  const [other_player_turn] = useSound(sounds?.other_player_turn);

  const DrawButtonClickAction = (type) => {
    let data = {};
    switch (type) {
      case "pass":
        play_passing();
         data = {
          action: 'pass-och',
          roomId,
          playerId: currentPlayerCard?.player_id,
        };
        break;

      case "draw":
        draw_sound();

       data = {
          action: 'draw-card-och',
          roomId,
          playerId: currentPlayerCard?.player_id,
        };
        break;
    
      default:
        break;
    }
   Socket.sendMessage(data);
  };
  const handleButtonClick = useCallback(
    _.debounce((type) => DrawButtonClickAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    []
  );
  return (
    <> 
      {isActivePlayer ? (
        <ActivePlayerPlaying
          roomId={roomId}
          DrawDeck={DrawDeck}
          ActiveCard={ActiveCard}
          currentPlayerCard={currentPlayerCard}
          handleButtonClick={handleButtonClick}
          crazySuit={crazySuit}
          play_eight={play_eight}
          play_card={play_card}
          your_turn={your_turn}
        />
      ) : (
        <PlayingWaitingScreen
        joke={joke}
          currentPlayerCard={currentPlayerCard}
          users={users}
          ActivePlayerInfo={ActivePlayerInfo}
          currentPlayer={currentPlayer}

        />
      )}
    </>
  );
};

export default OCHPlaying;
